import {BaseEntityUnDeletable} from '../../../common/entities';

export class EmploymentStatus extends BaseEntityUnDeletable {
    description: string;
    type: boolean;
}
